import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

//遍历所有图标名称
// Object.values(fas).forEach(element => {
//     console.log(element.iconName);
// });

Vue.component('font-awesome-icon', FontAwesomeIcon)
